import React from 'react';
import { Header, HeaderProps } from '../Header/Header';
import { BrannanWebsiteHeaderSettings } from '@apps/guest/websiteHeader';
import { HeaderPhoto } from './components/HeaderPhoto/HeaderPhoto';
import { EventPageType } from '@graphql/generated';

export interface HeaderV2Props extends HeaderProps {
  pageType?: EventPageType;
  websiteHeader: NonNullable<BrannanWebsiteHeaderSettings['websiteHeader']>;
  pageId?: string;
}

export const HeaderV2: React.FC<HeaderV2Props> = ({ websiteHeader, pageSlug, pageType, pageId, ...restProps }) => {
  return (
    <Header {...restProps}>
      <HeaderPhoto websiteHeader={websiteHeader} pageSlug={pageSlug} pageType={pageType} pageId={pageId} />
    </Header>
  );
};

export default HeaderV2;
